import { RouterProvider } from 'react-router/dom';

import { useAppUpdate } from 'src/hooks/useAppUpdate';

import { skyRouter } from 'src/routes/sky-router';

import { routesConfig } from './routes/config';
import { store } from 'src/store';
import { routerHistoryChange } from 'src/store/router/actions';

/**
 * Adding a new route to the navigation requires the following steps:
 * - add a new navigation to section mapping to the ./hooks/useSection.ts navKeys object
 * - add a new navigation tab to the side navigation component in ./sky-ui-lib/SkyAccMenu/index.tsx
 */

const router = skyRouter.init(routesConfig, (pathname) => {
  store.dispatch(routerHistoryChange(pathname));
});

export default function Router() {
  useAppUpdate();
  return <RouterProvider router={router} />;
}
